import * as yup from 'yup';

export const loginSchema = yup.object().shape({
    email: yup
      .string()
      .required('Username / Email is required')
      .test('email-or-username', 'Invalid email or username format', (value) => {
        if (!value) return false;
        // Email regex
        const emailRegex = /^[a-zA-Z0-9._%+!*-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // Username regex (alphanumeric, underscores, dots, min 3 chars)
        const usernameRegex = /^[a-zA-Z0-9._]{3,}$/;
        
        return emailRegex.test(value) || usernameRegex.test(value);
      }),
    password: yup
      .string()
      .required('Password is required')
      .min(1, 'Password is required'),
  });